import { render } from "./Meigaracompare.vue?vue&type=template&id=8fda45fc&scoped=true"
import script from "./Meigaracompare.vue?vue&type=script&lang=js"
export * from "./Meigaracompare.vue?vue&type=script&lang=js"

import "./Meigaracompare.vue?vue&type=style&index=0&id=8fda45fc&scoped=true&lang=scss"

import exportComponent from "/Users/dongjoosong/Code/dp7stage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fda45fc"]])

export default __exports__